/**
 * DHTMLX only auto-dismisses inline editors on `onEmptyClick` (and when switching
 * to another editable cell). Clicks on non-editable grid cells, the timeline, or
 * page chrome leave the editor focused — detect those as "outside".
 */
export function isInsideGanttInlineEditor(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return !!target.closest(
    '.gantt_grid_editor_placeholder, .gantt-date-editor',
  );
}
